import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import "./styles.css";

const InfoComplementar: React.FC<{ data: string }> = ({ data }) => {

  const accessibility = useAccessibility();

  return (
    <div className="procedimento-data-card" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
      <div>
        <span className="procedimento-data-key" style={accessibility.textStyleAccessibility}>Informações complementares</span>
        <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{data}</span>
      </div>
      
    </div>
  )
}

export default InfoComplementar;